const ICategory = {
  FEATURE: 'feature',
  BUG: 'bug',
  REFACTOR: 'refactor',
  DEPLOY: 'deploy',
  INFRA: 'infra'
};

export default ICategory;
